import { render, staticRenderFns } from "./menuTree.vue?vue&type=template&id=50aedb46&scoped=true&"
import script from "./menuTree.vue?vue&type=script&lang=js&"
export * from "./menuTree.vue?vue&type=script&lang=js&"
import style0 from "./menuTree.vue?vue&type=style&index=0&id=50aedb46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aedb46",
  null
  
)

export default component.exports